import { Box, Show } from "Components";
import { observer } from "mobx-react-lite";
import React, { useRef } from "react";
import { File } from "./File";
import { FilesViewModel } from "./FilesViewModel";
import { FileIcon } from "Assets/Icons/FileIcon";
import { toast, ToastOptions } from "react-hot-toast";
import { is } from "date-fns/locale";
import { position } from "styled-system";
export interface IFilesProps {
    className?: string;
    viewModel: FilesViewModel;
    styles?: any;
}

export const Files: React.FC<IFilesProps> = observer((props) => {
    const inputReference = useRef<any>(null);
    const { isMobile } = props.viewModel;
    const allowedFileTypes = [
        // Documents
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
        "text/plain",
        // Images
        "image/jpeg",
        "image/png",
        "image/gif",
        "image/bmp",
        "image/webp",
        // Media
        "audio/mpeg",
        "audio/wav",
        "video/mp4",
        "video/mpeg",
        // Archives
        "application/zip",
        "application/x-rar-compressed",
    ].join(", ");

    const isDisabled = (): boolean => {
        return !props.viewModel.addCommand.canExecute;
    };

    const onChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const files = event.target.files;

        // Check if any files are selected
        if (!files || files.length === 0) {
            return;
        }

        let showError = false;

        for (const file of files) {
            showError = !allowedFileTypes.includes(file.type);
            const mobileOptions: ToastOptions = {
                position: "top-center",
                style: {
                    marginTop: "50vh",
                },
            };

            const defaultStyle: ToastOptions = {
                position: "top-right",
                style: {
                    marginTop: "45px",
                },
            };

            if (showError) {
                toast.error(`Invalid file type: ${file.name}`, isMobile ? mobileOptions : defaultStyle);
                return;
            }
        }

        if (showError) {
            return;
        }

        props.viewModel.addCommand.execute(files);

        event.target.value = "";
    };

    const onDropFile = (event: React.DragEvent<HTMLElement>) => {
        event.preventDefault();
        props.viewModel.addCommand.execute(event.dataTransfer.files);
    };

    const onDragFile = (event: React.DragEvent<HTMLElement>) => {
        event.preventDefault();
    };

    const onClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
        inputReference?.current?.click();
    };

    const fileTypes = (): string => {
        return props.viewModel.fileTypes;
    };

    return (
        <div>
            <Show if={props.viewModel.fileViewModels.length == 0}>
                <Box onDragEnter={onDragFile} onDragOver={onDragFile} onDrop={onDropFile}>
                    <input accept={fileTypes()} multiple={false} ref={inputReference} style={{ display: "none" }} type="file" onChange={onChange} />
                    <button
                        disabled={isDisabled()}
                        onClick={onClick}
                        type="button"
                        style={{
                            background: "#F9F9F9",
                            border: "1px dashed ${theme.palette.tableHeader.main}",
                            width: "100%",
                            padding: "15px",
                            display: "flex",
                            textAlign: "center",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                            cursor: "pointer",
                        }}
                    >
                        <FileIcon />
                        <Box style={{ font: "normal normal normal 12px/16px Open Sans", letterSpacing: "-0.12px", color: "#8D8D8D" }} mt={"5px"}>
                            Click or drag a file to attach a file <br />
                            (.PDF .DOC .XLS .JPG .PNG .DOCX, testing)
                        </Box>
                    </button>
                </Box>
            </Show>
            <Show if={props.viewModel.fileViewModels.length > 0}>
                <Box dc={"1fr 1fr"} columnGap="30px" rowGap="15px">
                    {props.viewModel.fileViewModels.map((viewModel) => {
                        return <File className={props.className} viewModel={viewModel} key={viewModel.KEY} />;
                    })}
                </Box>
            </Show>
        </div>
    );
});
